import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CarouselBelt from '@cotyorg/ccx-organism-carousel/components/CarouselBelt';
import CarouselControls from '../CarouselControls';

const CarouselContents = ({
  carouselsStoreDataKey,
  setTransitionStart,
  setTransitionEnd,
  pageIds,
  buttons,
  pagination,
  setIndex,
  rightChevronIconSrc,
  leftChevronIconSrc,
  children,
  carouselData = {},
  onIndexChange,
  infinite,
  showPagination,
  noPerPage,
  sliderRef,
}) => {
  const {
    currentIndex,
    previousIndex,
    noOfPages,
    transitionStatus,
    currentItemIndex,
    previousItemIndex,
  } = carouselData;

  return (
    <>
      <CarouselBelt
        carouselsStoreDataKey={carouselsStoreDataKey}
        currentIndex={currentIndex}
        previousIndex={previousIndex}
        transitionStatus={transitionStatus}
        noOfPages={noOfPages}
        setTransitionStart={setTransitionStart}
        setTransitionEnd={setTransitionEnd}
        pageIds={pageIds}
        onIndexChange={onIndexChange}
        noPerPage={noPerPage}
        currentItemIndex={currentItemIndex}
        previousItemIndex={previousItemIndex}
        infinite={infinite}
      >
        {children}
      </CarouselBelt>
      <CarouselControls
        carouselsStoreDataKey={carouselsStoreDataKey}
        buttons={buttons}
        pagination={pagination}
        currentIndex={currentIndex}
        noOfPages={noOfPages}
        setIndex={setIndex}
        pageIds={pageIds}
        rightChevronIconSrc={rightChevronIconSrc}
        leftChevronIconSrc={leftChevronIconSrc}
        onIndexChange={onIndexChange}
        infinite={infinite}
        showPagination={showPagination}
        sliderRef={sliderRef}
      />
    </>
  );
};

CarouselContents.propTypes = {
  carouselsStoreDataKey: PropTypes.string.isRequired,
  setTransitionStart: PropTypes.func.isRequired,
  setTransitionEnd: PropTypes.func.isRequired,
  setIndex: PropTypes.func.isRequired,
  pageIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  buttons: PropTypes.objectOf(PropTypes.any),
  pagination: PropTypes.objectOf(PropTypes.any),
  rightChevronIconSrc: PropTypes.string,
  leftChevronIconSrc: PropTypes.string,
  children: PropTypes.node.isRequired,
  carouselData: PropTypes.objectOf(PropTypes.any).isRequired,
  onIndexChange: PropTypes.func,
  infinite: PropTypes.bool,
  showPagination: PropTypes.bool,
  noPerPage: PropTypes.number,
  sliderRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

export default CarouselContents;
